import client from '../client';

export const readWordList = ({ standardWord, useWord, category, page }) =>
    client.get(`/api/administrator/voca`, {
        params: {
            standardword: standardWord,
            useword: useWord,
            category: category.toLowerCase(),
            page,
            pagesize: 15
        }
    });

export const createWord = ({ category, standardWord, useWordList }) =>
    client.post('/api/administrator/voca', { category, standardWord, useWordList });

export const deleteWord = ({ category, deleteVoca }) =>
    client.delete('/api/administrator/voca', {
        data: { category, deleteVoca }
    });

export const updateWord = ({ category, id, standardWord, useWordList }) =>
    client.put(`/api/administrator/voca/${id}`, { category, standardWord, useWordList });

export const searchScenario = ( name ) =>
    client.get(`/api/administrator/search/scenarioname`, {
        params: {
            s: name
        }
    });

export const validateUniqueWord = ({ category, target, value }) =>
    client.post('/api/administrator/voca/validate', { category, target, value });